import z from 'zod';
import {standardSubjectSchema} from '../examModule/StandardSubject';
import {subjectLevelSchema} from '../examModule/SubjectLevel';
import {firestoreTimestampSchema} from '../_other/firestore';
import {quizSessionFeedbackSchema} from './QuizSessionFeedback';
import {quizSessionStateSchema} from './QuizSessionState';
import {quizTimedModeSchema} from './QuizTimedMode';
import {sessionQuestionSchema} from './sessionQuestion/sessionQuestionSchema';

/** Document shape as stored in DB (id from document id when reading). Module fields and questions are filled by trigger after initial write. */
export const quizSessionDbSchema = z.object({
  moduleId: z.string(),
  moduleName: z.string().optional(),
  level: subjectLevelSchema.optional(),
  examBoard: z.string().optional(),
  subject: standardSubjectSchema.optional(),
  topics: z.array(z.string()),
  difficulty: z.number().optional(),
  count: z.number().optional(),
  timedMode: quizTimedModeSchema,
  timeDurationSeconds: z.number().optional(),
  questions: z.array(sessionQuestionSchema).default([]),
  feedback: quizSessionFeedbackSchema.optional(),
  startedAt: firestoreTimestampSchema,
  endedAt: firestoreTimestampSchema.nullable().optional(),
  state: quizSessionStateSchema.optional(),
});

export interface QuizSessionDb extends z.infer<typeof quizSessionDbSchema> {}
